import { useTranslation } from 'react-i18next';
import { ModelName } from '@casops/store/api';
import { SafetyAlertType } from '@casops/store/apis/commonModels';
import { useOutletContext } from 'react-router-dom';
import { NoResults } from '@dmc/ui';
import SafetyAlerts, { SafetyAlertsProps } from './SafetyAlerts';
import { ReactElement } from 'react';

/**
 * Checks if the alert type is being tracked before rendering the CollectionView.
 * Shows a loading state or fallback message if the alert is untracked.
 */
export function SafetyAlertsController({ alertType }: SafetyAlertsProps): ReactElement {
  const { t } = useTranslation();

  const context = useOutletContext<Record<SafetyAlertType, boolean | undefined> | undefined>();
  const alertTypeTracked = context && context[alertType];

  if (alertTypeTracked === true) {
    return <SafetyAlerts alertType={alertType} />;
  } else if (alertTypeTracked === false) {
    const modelName =
      alertType === SafetyAlertType.Duress
        ? ModelName.SafetyAlertDuress
        : ModelName.SafetyAlertManDown;
    return <NoResults description={t('SafetyAlertsNotTracked', { modelName })} />;
  } else {
    return <NoResults description={t('Loading')} />;
  }
}

export default SafetyAlertsController;
